import styled from "styled-components";

export const InventoryContent = styled.div`
  & .ant-input-disabled{
    background-color: white;
    color: black;
    border: none;
  }
  & .ant-form-item{
    margin-bottom: 0;
  }
  /* padding: 0 10px; */
`